<template>
  <div class="print-container" v-if="!loading">
    <div class="page">
      <div class="text-center">
        <img src="@/assets/images/logos/logo-digiscore.jpg" style="max-width: 6cm" />
      </div>
      <br /><br />
      <h1 class="text-center" style="font-size: 34px;">
        {{ $t('surveyResultPDF.Title') }}
        <br /><br />
        <span class="color-black">{{ $lodash.get(YEnterpriseSectorUser, 'Name') }}</span>
        <br />
      </h1>
      <h2 class="text-center">
        {{ $t('surveyResultPDF.etablishedByAdn', { year: referenceDataSize.Year }) }}
      </h2>
      <br /><br />
      <h1 class="text-center">
        {{ $t('surveyResultPDF.surveyCompleted') }}<br />
        {{ $t('surveyResultPDF.surveyCompletedBy', {name: $lodash.get(surveySessionData, 'data.username') }) }} {{ $lodash.get(surveySessionData, 'data.UpdatedAt') | onlyDate }}
      </h1>
      <br /><br />
      <div style="padding:30px;margin-bottom: 30px;background-color:#f9f9f9;">
        <table cellpadding="0" cellspacing="0" style="width: 100%;max-width: 560px;margin: 0 auto;" border="0">
          <tr>
            <td style="font-size: 1.2rem;">
              <div style="height: 48px;line-height: 48px;">{{ $t('surveyResultPDF.globalScore') }}</div>
            </td>
            <td style="text-align: right; font-weight: bold;font-size: 1.2rem;">
              <div style="display: inline-block;border: 2px solid #52c3f1;border-radius: 50%;width: 48px;height: 48px;line-height: 48px;text-align: center;overflow: hidden;">{{ myScore }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding: .5rem 0 .5rem 0;font-style: italic;color: #52c3f1;">{{ $t('surveyResultPDF.scoreDistribution') }} :</td>
          </tr>
          <tr>
            <td style="border-bottom: 1px solid #eee;padding: 0 0 .5rem 0">
              <template v-if="referenceDataSize.Year === 2020">
                {{ $t('aboutAxis.infrastructureTitle') }}
              </template>
              <template v-else>
                {{ $t('surveyResult.howToRead2022.section1.axis1-title') }}
              </template>
            </td>
            <td style="text-align: right; font-weight: bold;border-bottom: 1px solid #eee;padding: .5rem 0">{{ myInfrastructureScore }}</td>
          </tr>
          <tr>
            <td style="border-bottom: 1px solid #eee;padding: .5rem 0">
              <template v-if="referenceDataSize.Year === 2020">
                {{ $t('aboutAxis.humanResourcesTitle') }}
              </template>
              <template v-else>
                {{ $t('surveyResult.howToRead2022.section1.axis2-title') }}
              </template>
            </td>
            <td style="text-align: right; font-weight: bold;border-bottom: 1px solid #eee;padding: .5rem 0">{{ myHumanResourceScore }}</td>
          </tr>
          <tr>
            <td style="border-bottom: 1px solid #eee;padding: .5rem 0">
              <template v-if="referenceDataSize.Year === 2020">
                {{ $t('aboutAxis.processFlowTitle') }}
              </template>
              <template v-else>
                {{ $t('surveyResult.howToRead2022.section1.axis3-title') }}
              </template>
            </td>
            <td style="text-align: right; font-weight: bold;border-bottom: 1px solid #eee;padding: .5rem 0">{{ myProcessFlowScore }}</td>
          </tr>
          <tr>
            <td style="padding: .5rem 0">
              <template v-if="referenceDataSize.Year === 2020">
                {{ $t('aboutAxis.salesProductsTitle') }}
              </template>
              <template v-else>
                {{ $t('surveyResult.howToRead2022.section1.axis4-title') }}
              </template>
            </td>
            <td style="padding: .5rem 0;text-align: right; font-weight: bold">{{ mySalesProductsScore }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div v-if="loadingResponse" class="multipages">
      <template v-if="referenceDataSize.Year === 2020">
        <h1>{{ $t('surveyResult.howToReadTitle') }}</h1><br />
        <p>{{ $t('surveyResult.howToRead') }}</p>
      </template>
      <template v-else>
        <HowToRead2022></HowToRead2022>
      </template>
      <template v-if="!compareSurveySessionData">
        <template v-if="referenceDataSize.Year === 2020">
          <Response2020 :content="responses" />
        </template>
        <template v-else>
          <h1 style="margin-top: 1em;">{{ $t('response.title') }}</h1>
          <Response :responses="responses" />
        </template>
      </template>
    </div>

    <div class="page">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"
        :reference="reference"
        :code="selectedCode"
        :category="selectedCategory"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="page" v-if="mySectorCode">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"        :reference="referenceDataSector"
        code="S"
        :category="mySectorCode"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="page" v-if="myEnterpriseSize">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'data.Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'data.UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'data.Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"        :reference="referenceDataSize"
        code="T"
        :category="myEnterpriseSize"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="page" v-if="myProvince">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"
        :reference="referenceDataProvince"
        code="P"
        :category="myProvince"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="page" v-if="myExportation">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"
        :reference="referenceDataExport"
        code="E"
        :category="myExportation"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="page" v-for="myTargetMarket of myTargetMarkets" :key="myTargetMarket">
      <SurveyResultComponent
        :companyName="$lodash.get(YEnterpriseSectorUser, 'Name')"
        :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'UpdatedAt'))"
        :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'Name')"
        :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'UpdatedAt'))"
        :reference="referenceDataTargetMarkets[myTargetMarket]"
        code="A"
        :category="myTargetMarket"
        :surveySession="$lodash.get(surveySessionData, 'data')"
        :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')" />
    </div>

    <div class="multipages">
      <Recommendation :print="true" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SurveyResultComponent from '@/components/SurveyResult.vue';
import Recommendation from '@/components/Recommendation.vue';
import Response from '@/components/Response.vue';
import Response2020 from '@/components/Response2020.vue';
import HowToRead2022 from '@/components/HowToRead2022.vue';
import { format } from 'date-fns';

const _ = require('lodash');

/* eslint-disable no-console */
export default {
  name: 'SurveyPDF',
  components: {
    SurveyResultComponent,
    Recommendation,
    Response,
    Response2020,
    HowToRead2022,
  },
  async mounted() {
    this.urlResult = _.replace(window.location, window.location.origin, '').substr(1);
    const mongoObjectId = new RegExp('^[0-9a-fA-F]{24}$');
    this.yEnterpriseSectorUserId = _.get(this.$route, 'params.yEnterpriseSectorUserId');
    this.yEnterpriseSectorUserIdClean = this.decodeUrl(this.yEnterpriseSectorUserId);
    const surveySessionId = this.decodeUrl(_.get(this.$route, 'params.sessionId'));
    const compareSurveySessionId = _.get(this.$route, 'params.compareSessionId');
    if (this.$route.name === 'SurveyPDFpublic') {
      this.publicPage = true;
    }
    if (!this.publicPage) {
      const token = _.get(this.$route, 'query.token');
      const whoAmI = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/whoAmI`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!_.isEmpty(whoAmI)) {
        if (_.isEmpty(whoAmI.data.FirstName && _.isEmpty(whoAmI.data.LastName))) {
          this.whoAmI = whoAmI.data.EmailAddress;
        } else {
          this.whoAmI = `${whoAmI.data.FirstName} ${whoAmI.data.LastName}`;
        }
      }
    }

    // La QueryString est un identifiant MongoDB
    if (mongoObjectId.test(this.yEnterpriseSectorUserIdClean)) {
      try {
        await Promise.all([
          axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${this.yEnterpriseSectorUserIdClean}/${surveySessionId}`, {
          }).then((data) => {
            this.surveySessionData = data;
            this.responses = _.get(this.surveySessionData, 'data.Response');
            this.loadingResponse = true;
            this.YEnterpriseSectorUser = data.data.yEnterpriseSector;
            this.enterprise = data.data.yEnterpriseSector;
          }),
        ]);

        if (compareSurveySessionId) {
          this.compareSurveySessionData = await axios.get(
            `${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${this.yEnterpriseSectorUserIdClean}/${compareSurveySessionId}`,
          );
          this.compareEnterprise = _.get(this.compareSurveySessionData, 'data.yEnterpriseSector');
          this.compareYEnterpriseSectorUser = this.compareEnterprise;
        }

        const referencePromises = [
          this.getReferenceData().then((data) => { this.referenceData = data; }),
        ];

        if (this.myProvince) {
          referencePromises.push(
            this.getReferenceData('P', this.myProvince).then((data) => { this.referenceDataProvince = data.data; }),
          );
        }

        if (this.mySectorCode) {
          referencePromises.push(
            this.getReferenceData('S', this.mySectorCode).then((data) => { this.referenceDataSector = data.data; }),
          );
        }

        if (this.myEnterpriseSize) {
          referencePromises.push(
            this.getReferenceData('T', this.myEnterpriseSize).then((data) => { this.referenceDataSize = data.data; }),
          );
        }

        if (this.myExportation) {
          referencePromises.push(
            this.getReferenceData('E', this.myExportation).then((data) => { this.referenceDataExport = data.data; }),
          );
        }

        this.myTargetMarkets.forEach((targetMarketCode) => {
          referencePromises.push(
            this.getReferenceData('A', targetMarketCode).then((data) => {
              this.referenceDataTargetMarkets[targetMarketCode] = data.data;
            }),
          );
        });
        await Promise.all(referencePromises);

        this.loading = false;
      } catch (e) {
        // @TODO  Handle error
        console.error('Cannot get survey session');
      }
      console.log('responses', this.responses);
      return true;
    }

    console.error('Wrong parameters');
    return false;
  },
  data() {
    return {
      namespace: _.get(this.$route, 'params.namespace'),
      yEnterpriseSectorUserId: '',
      paramsUrl: {},
      loading: true,
      loginFromNetSurvey: '',
      isAuthenticated: false,
      YEnterpriseSectorUser: {},
      enterprise: {},
      publicPage: false,
      referenceData: {},
      referenceDataSector: {},
      referenceDataSize: {},
      referenceDataProvince: {},
      referenceDataExport: {},
      referenceDataTargetMarkets: [],
      surveySessionData: {},
      compareSurveySessionData: null,
      compareEnterprise: null,
      compareYEnterpriseSectorUser: null,
      urlResult: '',
      selectedCode: undefined,
      selectedCategory: undefined,
      whoAmI: undefined,
      responses: [],
      loadingResponse: false,
    };
  },
  methods: {
    decodeUrl(url) {
      let finalString = '';
      finalString = decodeURIComponent(url);
      finalString = finalString.replace(/&amp;/g, '&');
      finalString = finalString.replace(/&nbsp;/g, '');
      finalString = finalString.replace(/ /g, '');
      return finalString;
    },
    async verifyLogin() {
      try {
        const token = await this.$auth.waitForToken();
        const ethnosLogin = this.loginFromNetSurvey;
        this.YEnterpriseSectorUser = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserByNamespace/${this.namespace}/${ethnosLogin}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return _.isEqual(
          parseInt(this.loginFromNetSurvey, 10),
          parseInt(_.get(this.YEnterpriseSectorUser, 'data.EthnosCredential.Login'), 10),
        );
      } catch {
        return false;
      }
    },
    async getReferenceData(code = undefined, category = undefined) {
      let referenceDataUser = {};
      if (code === undefined || category === undefined) {
        try {
          referenceDataUser = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/referenceByNamespaceCategoryId/${this.namespace}/G/GLOB`);
        } catch {
          return {};
        }
      } else {
        try {
          referenceDataUser = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/referenceByNamespaceCategoryId/${this.namespace}/${code}/${category}`);
        } catch (e) {
          return {};
        }
      }
      return referenceDataUser;
    },
    async selectFilter(code, category) {
      this.selectedCode = code;
      this.selectedCategory = category;
      this.referenceData = await this.getReferenceData(code, category);
    },
    convertDate(d) {
      let date;
      if (d) {
        date = format(new Date(d), 'dd/MM/yyyy');
        return date;
      }
      return date;
    },
  },
  computed: {
    reference() {
      return this.$lodash.get(this.referenceData, 'data', {});
    },
    mySectorCode() {
      return _.get(this.YEnterpriseSectorUser, 'data.SectorCode');
    },
    myEnterpriseSize() {
      let enterpriseSize = '';
      switch (_.get(this.surveySessionData, 'data.Category.Value')) {
        case 1:
          enterpriseSize = 'P1';
          break;
        case 2:
          enterpriseSize = 'P2-4';
          break;
        case 3:
          enterpriseSize = 'P5-9';
          break;
        case 4:
          enterpriseSize = 'P10-19';
          break;
        case 5:
          enterpriseSize = 'P20-49';
          break;
        case 6:
          enterpriseSize = 'P50-99';
          break;
        case 7:
          enterpriseSize = 'P100+';
          break;
        default:
          break;
      }
      return enterpriseSize;
    },
    myProvince() {
      let provinceCode = '';
      switch (_.get(this.enterprise, 'Address.province')) {
        case 'Brabant Wallon':
          provinceCode = 'BW';
          break;
        case 'Hainaut':
          provinceCode = 'HAI';
          break;
        case 'Liège':
          provinceCode = 'LG';
          break;
        case 'Luxembourg':
          provinceCode = 'LUX';
          break;
        case 'Namur':
          provinceCode = 'NAM';
          break;
        default:
          break;
      }
      return provinceCode;
    },
    myExportation() {
      switch (_.get(this.surveySessionData, 'data.Exportation.Value')) {
        case 1:
          return 'EXPORT';
        default:
          return 'NONEXP';
      }
    },
    myScore() {
      return Math.round((this.surveySessionData.data.Infrastructure.Value
              + this.surveySessionData.data.HumanResources.Value
              + this.surveySessionData.data.ProcessFlow.Value
              + this.surveySessionData.data.SalesProducts.Value) / 4);
    },
    myInfrastructureScore() {
      return this.surveySessionData.data.Infrastructure.Value;
    },
    myHumanResourceScore() {
      return this.surveySessionData.data.HumanResources.Value;
    },
    myProcessFlowScore() {
      return this.surveySessionData.data.ProcessFlow.Value;
    },
    mySalesProductsScore() {
      return this.surveySessionData.data.SalesProducts.Value;
    },
    myTargetMarkets() {
      const targetMarkets = [];
      const myValue = this.surveySessionData.data.TargetMarket.Value;
      /* eslint no-bitwise: ["error", { "allow": ["&"] }] */
      if (myValue & 8) {
        targetMarkets.push('ADM');
      }
      if (myValue & 4) {
        targetMarkets.push('NM');
      }
      if (myValue & 2) {
        targetMarkets.push('B2B');
      }
      if (myValue & 1) {
        targetMarkets.push('B2C');
      }
      return targetMarkets;
    },
  },
};
</script>

<style scoped>
.print-container {
  width: 100%;
  size: A4 portrait;
  font-family: 'Roboto', 'Open Sans', Arial, sans-serif;
}

.page {
  max-height: 257mm;
  height: 257mm;
  overflow: hidden;
  font-size: 80%;
}
.multipages {
  margin-bottom: 15mm;
  font-size: 80%;
  page-break-after: always;
}
.text-center {
  text-align: center;
}
.color-black {
  color: black;
}
.print-break-before{
    page-break-before: always;
}
.my-average{
    position: relative !important;
    bottom: unset !important;
    top: unset !important;
    left: 30mm !important;
    height: inherit!important;
    width: inherit!important;
    margin-top: 0mm!important;
    margin-bottom: 15mm!important;
    text-align: left !important;
}
</style>
<style>
@media print {
  .chart-container {
    max-height: 8cm !important;
  }
}
.chart-container > div:first-child {
  max-width: 210mm !important;
  height: 90mm !important;
}
h1 {
  font-size: 24px;
}
h2 {
  font-size: 20px;
}
h1, h2, h3, h4, h5, h6 {
  font-family: 'Roboto Slab', 'Open Sans', Arial, sans-serif;
  color: #0d93d2;
}
</style>
